/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { Component, OnInit } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';
import * as globalL10n from 'global-l10n';

import {
    IAviDiffGridConfig,
} from 'ng/modules/data-grid/components/avi-diff-grid/avi-diff-grid.types';

import * as l10n from './log-cinematic-section-headers.l10n';
import { TrafficLogCinematicStore } from '../../traffic-logs/traffic-log-cinematic/traffic-log-cinematic.store';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;
const { ...globalL10nKeys } = globalL10n;

/**
 * @description
 *     Component for displaying the HTTP headers section in a traffic log cinematic view.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'log-cinematic-section-headers',
    templateUrl: './log-cinematic-section-headers.component.html',
})
export class LogCinematicSectionHeadersComponent implements OnInit {
    public readonly l10nKeys = l10nKeys;

    /**
     * Object that includes HTTP request headers strings.
     */
    public readonly httpRequestHeaders$ = this.logCinematicStore.httpRequestHeaders$;

    /**
     * Object that includes HTTP response headers strings.
     */
    public readonly httpResponseHeaders$ = this.logCinematicStore.httpResponseHeaders$;

    /**
     * Config for the request headers diff grid.
     */
    public requestDiffGridConfig: IAviDiffGridConfig;

    /**
     * Config for the response headers diff grid.
     */
    public responseDiffGridConfig: IAviDiffGridConfig;

    constructor(
        private readonly logCinematicStore: TrafficLogCinematicStore,
        private readonly l10nService: L10nService,
    ) {
        this.l10nService.registerSourceBundles(dictionary);
    }

    /** @override */
    public ngOnInit(): void {
        this.requestDiffGridConfig = {
            leftField: {
                label: this.l10nService.getMessage(l10nKeys.headersReceivedFromClientLabel),
            },
            rightField: {
                label: this.l10nService.getMessage(l10nKeys.headersSentToServerLabel),
            },
            layout: {
                placeholderMessage:
                    this.l10nService.getMessage(globalL10nKeys.noHttpHeadersToShowPlaceholder),
            },
            isGridExpandable: true,
        };

        this.responseDiffGridConfig = {
            leftField: {
                label: this.l10nService.getMessage(l10nKeys.headersReceivedFromServerLabel),
            },
            rightField: {
                label: this.l10nService.getMessage(l10nKeys.headersSentToClientLabel),
            },
            layout: {
                placeholderMessage:
                    this.l10nService.getMessage(globalL10nKeys.noHttpHeadersToShowPlaceholder),
            },
            isGridExpandable: true,
        };
    }
}
